/**
 * Lichess-derived move accuracy: https://lichess.org/page/accuracy
 * Game aggregation is Chessla's arithmetic mean, not either site's game accuracy.
 *
 * winP(cp) = 50 + 50 * (2 / (1 + exp(-0.00368208 * cp)) - 1)
 * moveAcc  = clamp(103.1668 * exp(-0.04354 * max(0, wpBefore - wpAfter)) - 3.1669, 0, 100)
 * gameAcc  = mean(moveAcc) over all player moves with both evals present
 *
 * Scores are estimates, not calibrated ratings or a measure of decision difficulty.
 */
import type { AnalyzedMove } from "./types";
import { moveAccuracy } from "@/shared/utils/accuracy";

export { moveAccuracy, winProbability } from "@/shared/utils/accuracy";

/** Average accuracy across all player moves that have both eval fields set. */
export function computeGameAccuracy(playerMoves: AnalyzedMove[]): number {
  const scores: number[] = [];
  for (const m of playerMoves) {
    if (m.evalBeforeCp == null || m.evalAfterCp == null) continue;
    scores.push(m.centipawnLoss === 0 ? 100 : moveAccuracy(m.evalBeforeCp, m.evalAfterCp));
  }
  return scores.length > 0 ? scores.reduce((s, a) => s + a, 0) / scores.length : 0;
}
